import {
    QuickFilter, ToolbarButton,
} from '@mui/x-data-grid-pro'
import {
    styled,
} from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import {
    MAX_EXPANDED_INPUT_WIDTH,
} from './QuickFilterToolbarItem'

export const StyledQuickFilter = styled(QuickFilter)({
    display: 'grid',
    alignItems: 'center',
})
export const StyledWrapper = styled('div')({
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
})

type OwnerState = {
    expanded: boolean
}

export const StyledToolbarButton = styled(ToolbarButton)<{ ownerState: OwnerState }>(
    ({
        ownerState,
    }) => {
        return {
            gridArea: '1 / 1',
            width: 'min-content',
            height: 'min-content',
            zIndex: 1,
            opacity: ownerState.expanded ? 0 : 1,
            pointerEvents: ownerState.expanded ? 'none' : 'auto',
        }
    },
)

export const StyledTextField = styled(TextField)<{
    ownerState: OwnerState
}>(({
    ownerState,
}) => {
    return {
        gridArea: '1 / 1',
        overflowX: 'clip',
        width: ownerState.expanded ? '100%' : 'var(--trigger-width)',
        maxWidth: `${MAX_EXPANDED_INPUT_WIDTH}px`,
        opacity: ownerState.expanded ? 1 : 0,
        '& .MuiInputBase-root': {
            height: '30px',
        },
    }
})
